import { __rest } from 'tslib';
import { styled } from '@mui/material/styles';
import { X, Image } from '@piiqtechnologies/svg-icons';
import React, { useState } from 'react';
import ImageUploading from 'react-images-uploading';
import { PeekBox } from './PeekBox.js';
import { PeekStack } from './PeekStack.js';
import { PeekTypography } from './PeekTypography.js';

const StyledImage = styled("img")(({ theme }) => ({
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0",
    objectFit: "contain",
}));
const StyledPeekStack = styled(PeekStack)(({ theme }) => ({
    height: "100%",
    border: `${theme.spacing(0.1)} dashed ${theme.palette.grey[200]}`,
    borderRadius: 6,
    backgroundColor: theme.palette.grey[50],
    transition: "all .175s ease-in",
    overflow: "hidden",
    position: "relative",
    ":hover": {
        cursor: "pointer",
        backgroundColor: theme.palette.grey[500],
        img: {
            opacity: 0.3,
        },
    },
}));
const StyledContentWrapper = styled(PeekBox)(({ theme }) => ({
    height: "100%",
    width: "100%",
    position: "relative",
    display: "grid",
    color: theme.palette.text.primary,
    zIndex: 2,
    ":hover": {
        color: theme.palette.common.white,
    },
}));
const StyledCloseIcon = styled(X)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    fontSize: "1.2rem",
}));
const PeekImageSelector = (_a) => {
    var { uploadTitle, updateTitle, onChange, value, description, errorMessage, acceptTypeErrorMessage, maxFileSizeErrorMessage, resolutionErrorMessage, height, width } = _a, props = __rest(_a, ["uploadTitle", "updateTitle", "onChange", "value", "description", "errorMessage", "acceptTypeErrorMessage", "maxFileSizeErrorMessage", "resolutionErrorMessage", "height", "width"]);
    const [isHovering, setIsHovering] = useState(false);
    return (React.createElement(ImageUploading, Object.assign({}, props, { onChange: (values) => onChange(((values === null || values === void 0 ? void 0 : values.length) && values[0]) || null), multiple: false, value: (value && [value]) || [] }), ({ imageList, onImageUpload, dragProps, errors, onImageRemove }) => {
        var _a;
        return (React.createElement(PeekStack, { spacing: 0.5, height: height, width: width },
            React.createElement(StyledPeekStack, Object.assign({ direction: "column", onClick: onImageUpload, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false) }, dragProps),
                (!(imageList === null || imageList === void 0 ? void 0 : imageList.length) || isHovering) && (React.createElement(StyledContentWrapper, { alignItems: "center" },
                    isHovering && !!(imageList === null || imageList === void 0 ? void 0 : imageList.length) && (React.createElement(StyledCloseIcon, { onClick: (event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            onImageRemove(0);
                        } })),
                    React.createElement(PeekStack, { alignItems: "center", direction: "column", p: 1, spacing: 1 },
                        React.createElement(Image, null),
                        React.createElement(PeekTypography, { variant: "body2", fontWeight: "fontWeightBold", textAlign: "center" }, !!(imageList === null || imageList === void 0 ? void 0 : imageList.length) ? updateTitle : uploadTitle),
                        description && (React.createElement(PeekTypography, { variant: "body2", textAlign: "center", color: "error.main" }, description))))),
                !!(imageList === null || imageList === void 0 ? void 0 : imageList.length) && React.createElement(StyledImage, { src: (_a = imageList[0]) === null || _a === void 0 ? void 0 : _a.dataURL })),
            errors && (React.createElement(React.Fragment, null,
                errors.acceptType && (React.createElement(PeekTypography, { variant: "caption", color: "error.main" }, acceptTypeErrorMessage || errorMessage)),
                errors.maxFileSize && (React.createElement(PeekTypography, { variant: "caption", color: "error.main" }, maxFileSizeErrorMessage || errorMessage)),
                errors.resolution && (React.createElement(PeekTypography, { variant: "caption", color: "error.main" }, resolutionErrorMessage || errorMessage))))));
    }));
};

export { PeekImageSelector, PeekImageSelector as default };
